import { cva, VariantProps } from 'class-variance-authority'
import { DotIcon, LoaderIcon } from 'lucide-react'

import { cn } from '@/ui/utils/style'

const networkStatusBadgeVariants = cva('flex w-fit items-center gap-0.5 rounded-full py-[3px] pr-1.5 pl-1', {
  variants: {
    status: {
      connected: 'bg-system-success-primary text-system-success-secondary',
      pending: 'bg-brand-secondary text-brand-secondary',
    },
  },
})

export interface NetworkStatusBadgeProps {
  status: NonNullable<VariantProps<typeof networkStatusBadgeVariants>['status']>
  className?: string
}

export function NetworkStatusBadge({ status, className }: NetworkStatusBadgeProps) {
  const [Icon, text] = status === 'connected' ? [DotIcon, 'Connected'] : [LoaderIcon, 'Confirm in wallet']

  return (
    <div className={cn(networkStatusBadgeVariants({ status }), className)}>
      <Icon className={cn('icon-size-xxs', status === 'pending' && 'animate-[spin_2s_linear_infinite]')} />
      <div className="typography-label-4">{text}</div>
    </div>
  )
}
